<template lang="pug">
    v-layout(row wrap)
        v-flex.xs12.d-flex.justify-end
            v-btn.mt-3(
                dark
                color="success"
                @click="linkProducts"
                v-if="$can('EDIT_PURCHASE_PROVIDER')"
                style="max-width: 200px;"
                )
                v-icon.mr-2(dark) attachment
                | Asociar Productos
        v-flex(md12)
            model-data-table( :headers="headers" no-actions ref="table" :service="model" :param-filter="{ pch_provider_id: providerID }" :attach-params='attachParams' )
            //crud-data-table( :filters='[]' :headers="headers" ref="table" :service="service"  @show="submitShow" :deleteButton="()=>false"  )
        v-flex(md12)
            PickerItemDialog(ref="dialog" @submit="submitProductsDialog" allowItemFilter  :providerId="providerID" )
</template>

<script>
import {
    CrudDataTable,
} from '@/components/reusable_components'
import ProviderProductsHeader from '@/views/provider/table/ProviderProductsHeader'
import { mapActions, mapState } from 'vuex'
import { getFetchDataFunction } from '@/services/api/DataTableService'
import api from '@/services/api/api'
import ProductModel from '@/models/Warehouse/WhProduct'
import PchProviderMdl from '@/models/Purchase/PchProvider'
import PickerItemDialog from '@/components/Dialogs/LinkProductDialog.vue'
import ServicePickerDialog from '@/services/api/product/fetchDataTable.js'
//
import ProductService from '@/services/api/provider/ProviderLinkProductDTService.js'
import ProviderService from '../../services/api/provider/ProviderService.js'
//
import { ModelDataTable } from "@/components/reusable_components/next"
//
import WhProductModel from '@/models/Warehouse/WhProduct'
import WhProductService from '@/services/api/Warehouse/WhProduct'
//
export default {
    name: 'provider-products',
    props: {},
    data: function() {
        return {
            attachParams: {
                append: 'stocks,last_provider_code'
            },
            model: WhProductModel,
            service: {
                dtFetchData: {},
            },
            headers: ProviderProductsHeader,
            deleteId: null,
            providerID: null,
        }
    },
    computed: {},
    methods: {
        /**
         *
         */
        submitDialogShow() {
            this.$refs.dialog.open = true
            this.$refs.dialog.fetchDataWhProduct()
        },
        /**
         *
         */
        ...mapActions('MenuesModule', {
            setTitleTopBar: 'setTitleTopBar',
        }),
        /**
         *
         */
        ...mapActions('SnackbarModalModule', {
            initSnackbar: 'initSnackbar',
            hideSnack: 'hideSnack',
            resetSnackbarState: 'resetSnackbarState',
            setMessageConfirmSnack: 'setMessageConfirmSnack',
        }),
        /**
         *
         */
        linkProducts() {
            this.submitDialogShow()
        },
        /**
         *
         */
        async submitProductsDialog(e) {
            const wh_products = e.selected.map(item => {
                return item.id
            })
            let data = { wh_products }
            let response = await ProviderService.linkProductToProduct(this.providerID, data)
            this.SnackBarResponse(response)
        },
        /*
         *
         */
        submitShow(id) {
            this.$router.push(
                `/providers/${this.$route.params.id}/product/${id}`
            )
        },
        /*
         *
         */
        fetchDataToTable() {
            const route = `${api.PCH_PROVIDER}/${this.$route.params.id}`
            let model = PchProviderMdl
            this.service.dtFetchData = getFetchDataFunction(
                route,
                [],
                ['product_catalogue'],
                response => {
                    let newResponse = {}
                    newResponse.data = response.data.product_catalogue
                    return newResponse
                }
            )
        },
        /**
         *
         */
        SnackBarResponse(response = null) {
            //
            if (response.status === 201) {
                //call snack
                this.resetSnackbarState()
                this.initSnackbar(
                    this.fillSnack(
                        'success',
                        'Éxito',
                        'Asociación de productos correcta',
                        false
                    )
                )
                this.$refs.table.refresh()
            } else if (response.status === 'error') {
                //call snack
                this.resetSnackbarState()
                this.initSnackbar(
                    this.fillSnack('error', 'Error', response.message, false)
                )
            }
        },
        /**
         * 
         */
        setProviderID(){
            this.providerID = this.$route.params.id
        }
    },
    watch: {},
    components: {
        CrudDataTable,
        PickerItemDialog,
        ModelDataTable,
    },
    mixins: [],
    filters: {},
    // Lifecycle Methods
    //
    // beforeCreate: function(){...},
    // created: function(){...},
    beforeMount: function() {
        this.setTitleTopBar('Datos proveedor')
        this.fetchDataToTable()
        this.setProviderID()
    },
    mounted: function() {
        this.fetchDataToTable()
    },
    // beforeUpdate: function(){...},
    // updated: function(){...},
    // beforeDestroy: function(){...},
    // destroyed: function(){...},
    //
    // End Lifecycle Methods
}
</script>

<style lang="scss">
.products-dialog-picker .full-width-datatable .v-table__overflow {
    max-height: 35vh;
    overflow-y: auto;
}
.v-dialog {
    background: white;
}
</style>